// extracted by css-extract-rspack-plugin
export default {"errors":"Errors__errors--Tu3HD","errorHeadding":"Errors__errorHeadding--UlDrv","error":"Errors__error--Sir2H"};